import React, {FC} from 'react'
import {createPortal} from 'react-dom'
import {InputDialog, Text} from 'wix-ui-tpa/cssVars'
import {useTPAComponentsContext} from 'wix-ui-tpa/TPAComponentsConfig'

import {cancellationPolicyDialogDataHooks} from './constants'
import {classes} from './styles.st.css'

interface Props {
  t: (key: string, options?: Record<string, unknown>) => string
  isOpen: boolean
  policy?: string | null
  onClose: () => void
}

export const CancellationPolicyDialog: FC<Props> = ({t, isOpen, policy, onClose}) => {
  const {rtl} = useTPAComponentsContext()

  if (!isOpen || !policy || typeof document === 'undefined') {
    return null
  }

  const title = t('uou-reservations.reservation-confirmation.cancel-fee-warning.view-policy')

  return createPortal(
    <div dir={rtl ? 'rtl' : undefined}>
      <InputDialog
        isOpen
        onClose={onClose}
        title={title}
        closeButtonAriaLabel={t('uou-reservations.shared.modal-close-button')}
        primaryButton={{
          text: t('uou-reservations.reservation-details.terms-privacy.close'),
          onClick: onClose,
        }}
        forceBWTheme
        className={classes.policyDialog}
      >
        <Text
          tagName="p"
          className={classes.dialogContent}
          data-hook={cancellationPolicyDialogDataHooks.content()}
        >
          {policy}
        </Text>
      </InputDialog>
    </div>,
    document.body,
  )
}

export default CancellationPolicyDialog
